module.exports = __webpack_public_path__ + "img/stwo.fa727ef5.png";